import React, { useEffect, useState } from 'react';
import {
  Document,
  Text,
  Page,
  Image,
  Font,
  StyleSheet,
  View,
} from '@react-pdf/renderer';
import logo from '../../../assets/logo-dashboard.png';
import { devURL, titleCase } from '../../../utils';
import axios from 'axios';

export default function Receipt({ transfer }) {
  Font.register({
    family: 'Nunito',
    src: 'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTM9jo7eTWk.ttf',
  });

  const styles = StyleSheet.create({
    body: {
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 16,
      marginTop: 20,
      textAlign: 'left',
      fontFamily: 'Nunito',
      fontWeight: 'bold',
    },
    heading: {
      fontSize: 12,
      textAlign: 'left',
      marginTop: 12,
      color: 'grey',
      fontFamily: 'Nunito',
    },
    colEnd: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'end',
      alignItems: 'flex-end',
    },
    detail: {
      fontSize: 12,
      marginTop: 6,
      fontWeight: 'light',
      fontFamily: 'Nunito',
    },
    image: {
      marginVertical: 15,
      width: 140,
    },
    footer: {
      fontSize: 10,
      marginTop: 8,
      textAlign: 'center',
      fontFamily: 'Nunito',
      position: 'absolute',
      bottom: 0,
      marginHorizontal: 'auto',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 10,
    },
  });

  const createDate = new Date(transfer.createdAt);
  const transferDate = new Date(transfer.date_of_transfer);
  const token = localStorage.getItem('swToken');

  const [recipient, setRecipient] = useState({
    bank_name: 'try again',
    bank_account_number: '',
    ifsccode: '',
  });

  useEffect(() => {
    getRecipientDetails();
  }, []);

  const getRecipientDetails = () => {
    axios
      .get(`${devURL}/recipient/transaction-details/${transfer.recipient_id}`, {
        headers: { token: token },
      })
      .then((res) => {
        setRecipient(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Document>
      <Page style={styles.body}>
        <Image style={styles.image} src={logo} />
        <Text style={styles.title}>Transfer confirmation</Text>
        <Line />
        <Row>
          <View>
            <Text style={styles.heading}>Transfer created</Text>
            <Text style={styles.detail}>{createDate.toDateString()}</Text>
          </View>
          <View style={styles.colEnd}>
            <Text style={styles.heading}>Date of transfer</Text>
            <Text style={styles.detail}>{transferDate.toDateString()}</Text>
          </View>
        </Row>
        <Row>
          <View>
            <Text style={styles.heading}>Transfer ID</Text>
            <Text style={styles.detail}>#{transfer.transaction_id}</Text>
          </View>
          <View style={styles.colEnd}>
            <Text style={styles.heading}>Deposit Code</Text>
            <Text style={styles.detail}>{transfer.deposit_code}</Text>
          </View>
        </Row>
        <Text style={styles.title}>Transfer overview</Text>
        <Line />
        {transfer.discount ? (
          <Row>
            <View>
              <Text style={styles.heading}>Original amount</Text>
              <Text style={styles.detail}>
                {transfer.discount.old_sent_amount} EUR
              </Text>
            </View>
            <View style={styles.colEnd}>
              <Text style={styles.heading}>Discount</Text>
              <Text style={styles.detail}>
                {transfer.discount.discount} EUR
              </Text>
            </View>
          </Row>
        ) : null}
        <Row>
          <View>
            <Text style={styles.heading}>Amount sent</Text>
            <Text style={styles.detail}>{transfer.sent_amount} EUR</Text>
          </View>
          <View style={styles.colEnd}>
            <Text style={styles.heading}>Our fee</Text>
            <Text style={styles.detail}>{transfer.fee} EUR</Text>
          </View>
        </Row>
        <Row>
          <View>
            <Text style={styles.heading}>Amount received</Text>
            <Text style={styles.detail}>{transfer.received_amount} INR</Text>
          </View>
          <View style={styles.colEnd}>
            <Text style={styles.heading}>Exchange rate</Text>
            <Text style={styles.detail}>1 EUR = {transfer.rate} INR</Text>
          </View>
        </Row>
        <Text style={styles.title}>Recipient details</Text>
        <Line />
        <Row>
          <View>
            <Text style={styles.heading}>Recipient Name</Text>
            <Text style={styles.detail}>
              {titleCase(transfer.recipient_name)}
            </Text>
            <Text style={styles.detail}>({transfer.recipient_nick_name})</Text>
          </View>
          <View style={styles.colEnd}>
            <Text style={styles.heading}>Account details</Text>
            <Text style={styles.detail}>{recipient.bank_name}</Text>
            <Text style={styles.detail}>{recipient.bank_account_number}</Text>
            <Text style={styles.detail}>{recipient.ifsccode}</Text>
          </View>
        </Row>
        <Row>
          <View>
            <Text style={styles.heading}>UTR</Text>
            <Text style={styles.detail}>{transfer.dst_bank_ref}</Text>
          </View>
        </Row>
        <View style={styles.footer}>
          <Text>ScopeX,Dviz Limited,UK.</Text>
          <Text>Email: contact@scopex.money</Text>
        </View>
      </Page>
    </Document>
  );
}

function Line() {
  return (
    <View
      style={{
        width: '100%',
        height: 1,
        backgroundColor: 'grey',
        marginTop: 5,
        marginBottom: 5,
      }}
    ></View>
  );
}

function Row({ children }) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginRight: 10,
      }}
    >
      {children}
    </View>
  );
}
